import { render, staticRenderFns } from "./MenuRock.vue?vue&type=template&id=6278aa2c&scoped=true&"
import script from "./MenuRock.vue?vue&type=script&lang=js&"
export * from "./MenuRock.vue?vue&type=script&lang=js&"
import style0 from "./MenuRock.vue?vue&type=style&index=0&id=6278aa2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6278aa2c",
  null
  
)

export default component.exports